import { render, staticRenderFns } from "./viewObservation.vue?vue&type=template&id=eb3c14c4&scoped=true&"
import script from "./viewObservation.vue?vue&type=script&lang=js&"
export * from "./viewObservation.vue?vue&type=script&lang=js&"
import style0 from "./viewObservation.vue?vue&type=style&index=0&id=eb3c14c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3c14c4",
  null
  
)

export default component.exports